import React from "react";

/** Inline SVG icons for skills without reliable Iconify coverage. */
export const skillSvgIcons = {
  keras: (
    <svg viewBox="0 0 32 32" width="1em" height="1em" aria-hidden="true">
      <rect width="32" height="32" rx="6" fill="#D00000" />
      <path
        d="M9 7h4.2v7.2L19.8 7H25l-7.6 8.2L25.2 25H19.8l-6.6-8.4V25H9V7z"
        fill="#fff"
      />
    </svg>
  ),
  xgboost: (
    <svg viewBox="0 0 32 32" width="1em" height="1em" aria-hidden="true">
      <rect width="32" height="32" rx="6" fill="#1A2E1A" />
      <path
        d="M8 22 L12 10 L16 18 L20 8 L24 22"
        fill="none"
        stroke="#5EB85E"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="8" r="2.2" fill="#FFD166" />
    </svg>
  ),
  langsmith: (
    <svg viewBox="0 0 32 32" width="1em" height="1em" aria-hidden="true">
      <rect width="32" height="32" rx="6" fill="#1C3C3C" />
      <path
        d="M8 22V10h3.2c3.4 0 5.4 1.7 5.4 4.4 0 1.7-.8 3-2.2 3.8L18.8 22h-3.6l-3.4-3.6H11.2V22H8zm3.2-5.8h.8c1.5 0 2.4-.7 2.4-2s-.9-2-2.4-2h-.8v4z"
        fill="#fff"
      />
      <circle cx="23" cy="11" r="2.2" fill="#2DD4BF" />
      <path
        d="M21 15.5c0-1.2.9-2.2 2-2.2s2 1 2 2.2c0 2.2-2 3.3-2 4.8h-1.6"
        fill="none"
        stroke="#2DD4BF"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  ),
  faiss: (
    <svg viewBox="0 0 32 32" width="1em" height="1em" aria-hidden="true">
      <rect width="32" height="32" rx="6" fill="#0668E1" />
      <circle cx="11" cy="12" r="3" fill="#fff" />
      <circle cx="21" cy="10" r="2.2" fill="#A7D0FF" />
      <circle cx="18" cy="18" r="2.6" fill="#fff" />
      <circle cx="10" cy="21" r="2" fill="#A7D0FF" />
      <path
        d="M13.5 13.5 L16.5 16.5 M19.5 11.5 L17.2 16 M12 19.5 L16.2 17"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.85"
      />
    </svg>
  ),
  pinecone: (
    <svg viewBox="0 0 32 32" width="1em" height="1em" aria-hidden="true">
      <rect width="32" height="32" rx="6" fill="#000" />
      <path
        d="M16 5 L22 12 L19.5 12.5 L24 19 L19 18.5 L22 26 L16 22.5 L10 26 L13 18.5 L8 19 L12.5 12.5 L10 12 Z"
        fill="#1CEC83"
      />
      <circle cx="16" cy="14" r="2" fill="#000" />
    </svg>
  ),
  swift: (
    <svg viewBox="0 0 32 32" width="1em" height="1em" aria-hidden="true">
      <defs>
        <linearGradient id="swiftGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F88A36" />
          <stop offset="100%" stopColor="#F05138" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="6" fill="url(#swiftGrad)" />
      <path
        d="M7.5 21.5c4.8-1.2 9.2-4.2 12.4-8.2-1.8 2.4-4.2 4.4-7 5.8 3.8-.4 7.2-2.2 9.8-5 1.1-1.2 2-2.5 2.6-4-2.6 3.4-6.2 6-10.2 7.6 3.2.2 6.4-.6 9-2.4-3.2 3.2-7.4 5.4-12 6.2-1.6.3-3.2.3-4.6 0z"
        fill="#fff"
      />
    </svg>
  ),
  airflow: (
    <svg viewBox="0 0 32 32" width="1em" height="1em" aria-hidden="true">
      <rect width="32" height="32" rx="6" fill="#017CEE" />
      <g fill="#fff">
        <circle cx="16" cy="16" r="3.2" />
        <circle cx="16" cy="6.5" r="2.2" />
        <circle cx="16" cy="25.5" r="2.2" />
        <circle cx="6.5" cy="16" r="2.2" />
        <circle cx="25.5" cy="16" r="2.2" />
        <circle cx="9.3" cy="9.3" r="2" />
        <circle cx="22.7" cy="9.3" r="2" />
        <circle cx="9.3" cy="22.7" r="2" />
        <circle cx="22.7" cy="22.7" r="2" />
      </g>
      <g stroke="#B8DCFF" strokeWidth="1.4" fill="none" opacity="0.9">
        <line x1="16" y1="9" x2="16" y2="12.5" />
        <line x1="16" y1="19.5" x2="16" y2="23" />
        <line x1="9" y1="16" x2="12.5" y2="16" />
        <line x1="19.5" y1="16" x2="23" y2="16" />
        <line x1="11" y1="11" x2="13.5" y2="13.5" />
        <line x1="18.5" y1="13.5" x2="21" y2="11" />
        <line x1="11" y1="21" x2="13.5" y2="18.5" />
        <line x1="18.5" y1="18.5" x2="21" y2="21" />
      </g>
    </svg>
  ),
};
